// Reactive-form control names and validation error keys used by the
// fee group/subgroup create form. Centralized so the template and the
// component reference the same identifiers instead of duplicated literals.
export const SUBGROUP_FIELD = {
  ID: 'id',
  NAME: 'name',
  PRICE: 'price',
  ALLOW_CUSTOM_AMOUNT: 'allowCustomAmount',
  MENTOR_NAME: 'mentorName',
  MENTOR_PHONE: 'mentorPhone',
  MENTOR_EMAIL: 'mentorEmail',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  FREQUENCY: 'frequency',
  PAYMENT_FLOW: 'paymentFlow'
} as const;

export const FORM_ERROR = {
  REQUIRED: 'required',
  MAX_LENGTH: 'maxlength',
  MIN: 'min',
  PATTERN: 'pattern',
  EMAIL: 'email'
} as const;
